import { render, staticRenderFns } from "./MenuJourneyFilters.vue?vue&type=template&id=59179bc2&scoped=true&"
import script from "./MenuJourneyFilters.vue?vue&type=script&lang=js&"
export * from "./MenuJourneyFilters.vue?vue&type=script&lang=js&"
import style0 from "./MenuJourneyFilters.vue?vue&type=style&index=0&id=59179bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59179bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59179bc2')) {
      api.createRecord('59179bc2', component.options)
    } else {
      api.reload('59179bc2', component.options)
    }
    module.hot.accept("./MenuJourneyFilters.vue?vue&type=template&id=59179bc2&scoped=true&", function () {
      api.rerender('59179bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuJourneyFilters.vue"
export default component.exports